const blogs = {
    getBlogs: () => "api/get-all-blogs",
}

export default blogs